import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router';
import HeroBackground from '../ui/HeroBackground';
import CastFigure from '../../motion/CastFigure';
import { castKey, hasPose } from '../../data/cast';

function SealTab({ team, reduced }) {
  const [pose, setPose] = useState('base');
  const timer = useRef(0);
  const key = castKey(team.manager);

  useEffect(() => () => clearTimeout(timer.current), []);

  const tease = () => {
    if (reduced || !hasPose(key, 'shock')) return;
    clearTimeout(timer.current);
    setPose('shock');
    timer.current = setTimeout(() => setPose('base'), 260);
  };

  const settle = () => {
    clearTimeout(timer.current);
    setPose('base');
  };

  return (
    <Link
      to={`/draft-grades/${team.slug}`}
      className={`rg-seal-tab paper ${reduced ? 'is-broken' : ''}`}
      onMouseEnter={tease}
      onMouseLeave={settle}
      onFocus={tease}
      onBlur={settle}
      aria-label={`${team.manager} dossier${reduced ? `, grade ${team.letter}` : ', sealed'}`}
    >
      <CastFigure
        name={team.manager}
        pose={pose}
        trigger="none"
        preload={false}
        className="rg-seal-tab__figure"
        alt=""
      />
      <span className="rg-seal-tab__name">{team.manager}</span>
      <span className="rg-seal-tab__wax" aria-hidden="true">
        <span>{reduced ? team.letter : '?'}</span>
      </span>
    </Link>
  );
}

export default function RegistrarHero({ season, teams, pickCount, roundCount, reduced }) {
  const scrollTo = (id) => (event) => {
    event.preventDefault();
    document.querySelector(id)?.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  };

  return (
    <HeroBackground variant="gold" backdrop="studio" className="rg-hero border-b border-accent-gold/30 px-6 pb-14 pt-8 md:px-14 md:pb-20 md:pt-10">
      <div className="rg-issue-bar">
        <span>Vol XIV</span>
        <span>The Office of the Registrar</span>
        <span>{season} · Draft Issue</span>
      </div>

      <div className="rg-hero__copy">
        <p className="rg-eyebrow">Vol XIV · Office of the Registrar</p>
        <h1 className="rg-hero__title">
          <span>Seventeen rounds.</span>
          <span className="rg-hero__gold">
            One curve.
            <i className="absolute inset-0 bg-halftone opacity-30 mix-blend-overlay" aria-hidden="true" />
          </span>
        </h1>
        <p className="rg-hero__dek">
          Every one of the {pickCount} picks was scored against what its slot was worth. The curve was not applied gently.
        </p>
      </div>

      <div className="rg-seal-wall" data-testid="registrar-seal-wall">
        {teams.map((team) => <SealTab key={team.slug} team={team} reduced={reduced} />)}
      </div>

      <div className="rg-hero__actions">
        <a className="rg-action rg-action--primary" href="#registrar-countdown" onClick={scrollTo('#registrar-countdown')}>
          Break the seals
        </a>
        <a className="rg-action" href="#registrar-ledger" onClick={scrollTo('#registrar-ledger')}>
          Skip to the standings
        </a>
      </div>
      <p className="rg-hero__file-count">{teams.length} dossiers · {pickCount} picks · {roundCount} rounds · 1 curve</p>
    </HeroBackground>
  );
}
